import React from "react";

import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";

import StyledTooltip from "../../../../Common/UIComponents/StyledTooltip";
import { notDoableTestMessage } from "../../../utils";
import { CHAR_LIMITS } from "../../Constant";

import "../../SubmissionForm.css";

export default function AddUpdateSampleButton({
  waitingForAddEditAPI,
  sampleEditingIdx,
  handleSaveEditedSample,
  handleAddSample,
  handleCancelEditSample,
  invalidInputFound,
  invalidMandatoryFound,
  invalidTest,
  notDoableTest,
  sampleCategory,
  disableAddSample,
  sampleIDGenerationError,
  generatedSampleID,
  isPesticideSampleEmpty,
  submissionEditingSample,
  isLoading,
  setEditingSubmittedSampleComposite,
  noTestsSelected,
}) {
  const invalidSampleIDLength = generatedSampleID.length > CHAR_LIMITS.sample_id;
  const disableForNoTests = sampleEditingIdx === -1 && noTestsSelected;
  const disable = waitingForAddEditAPI
    || invalidInputFound
    || invalidMandatoryFound
    || invalidTest
    || notDoableTest
    || invalidSampleIDLength
    || sampleIDGenerationError
    || isPesticideSampleEmpty
    || disableForNoTests;

  let message = "";
  if (sampleIDGenerationError) {
    message = "Unable to generate Sample ID. Please try again.";
  } else if (invalidSampleIDLength) {
    message = `Sample ID exceeds the maximum length of ${CHAR_LIMITS.sample_id} characters.`;
  } else if (invalidMandatoryFound) {
    message = "All required fields must be filled.";
  } else if (invalidInputFound) {
    message = "Some fields contain invalid characters or formats.";
  } else if (notDoableTest) {
    message = notDoableTestMessage(sampleCategory);
  } else if (invalidTest) {
    message = "Selected replicate tests cannot be used with a Sample ID containing a replicate tag.";
  } else if (isPesticideSampleEmpty) {
    message = "MRL test sample type is required for the selected MRL test.";
  } else if (disableForNoTests) {
    message = "No tests selected for this sample.";
  }
  /**
   * Update the edit sample or Edit the submitted sample
   */
  const handleUpdateEdit = async () => {
    if (submissionEditingSample) {
      const submitEdit = true;
      setEditingSubmittedSampleComposite(false);
      await handleSaveEditedSample(submitEdit);
    } else {
      handleSaveEditedSample();
    }
  };

  const onClick = sampleEditingIdx > -1 ? handleUpdateEdit : handleAddSample;
  const isUpdateMode = sampleEditingIdx > -1 || disableAddSample;
  const isAddGhost = sampleEditingIdx === -1 && !disableAddSample;

  return (
    <div className="new-submission-pages-button-div">
      <StyledTooltip
        title={message}
        placement="top"
      >
        <span className="new-submission-pages-button-tooltipWrap">
          <Button
            type="primary"
            htmlType="button"
            ghost={isAddGhost && !disable}
            disabled={disable}
            className="new-submission-pages-button"
            onClick={onClick}
            loading={isLoading}
            icon={<PlusOutlined className="new-submission-plus-icon" aria-hidden />}
          >
            <span>{isUpdateMode ? "Update Sample" : "Add Sample"}</span>
          </Button>
        </span>
      </StyledTooltip>

      {(!submissionEditingSample && sampleEditingIdx > -1) && (
      <Button
        type="default"
        htmlType="button"
        className="new-submission-pages-button new-submission-pages-button--cancel"
        onClick={handleCancelEditSample}
        loading={isLoading}
        disabled={isLoading}
      >
        Cancel
      </Button>
      )}
    </div>
  );
}
